import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import './BookDetails.css';


const LandingPage = () => {
  const [subscriptionStatus, setSubscriptionStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const subscribeUser = async (email) => {
    setIsLoading(true);
    try {
      const response = await fetch('https://connect.mailerlite.com/api/subscribers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_MAILERLITE_API_KEY}`,
        },
        body: JSON.stringify({
          email: email.get('email'),
          status: "unconfirmed",
          groups: ["136114632182990219"],
        })
      });

      // Log the response for debugging
      console.log('Response status:', response.status);

      const data = await response.json();
      console.log('Response data:', data);

      if (response.ok) {
        setSubscriptionStatus('Successfully subscribed!');
        document.getElementById('subscription-form').reset();
      } else {
        setSubscriptionStatus(`Error: ${data.message || 'Failed to subscribe'}`);
      }
    } catch (error) {
      console.error('Detailed error:', error);
      setSubscriptionStatus('Error subscribing user');
    } finally {
      setIsLoading(false);
    }
  };

  return (

    <section id="lp_book-details" class="lp_book-details">
      <div className="lp_book-details_full">
        <h4>Children of Nemia is a coming of age adventure about self-discovery, found family, and choosing hope over helplessness.</h4>
        <p className='review'>I loved how the author blended tribal culture with magic and myth in a setting that felt very real. I also enjoyed how the author told the story, created a believable world, and ensured that readers were truly invested until the end. Children of Nemia is a fantastic story with enough twists to keep you entertained for hours. Highly recommended!
          <br /> <em><a href="https://readersfavorite.com/" target="blank">- Readers' Favorite (5 star review)</a></em></p>
        <p className='review'>It’s a book that feels written with love—and for readers who enjoy watching young heroes find their place in a complicated world, that love makes all the difference.
          <br /> <em><a href="https://fanfiaddict.com/" target="blank">- FanFi Addict</a></em></p>
      </div>
      <div className="lp_book-details_content">
        <div className="lp_book-details_text">
          <h1>Buy Now: select your retailer</h1>
          <ul>
            <li><a href="https://thearcanist.net/nemia/" target="blank"><strong>The Arcanist</strong></a> <em>(support local publishers)</em></li>
            <li><a href="https://shop.ingramspark.com/b/084?params=OgUQSXMBpRN5JysGYwqIhqdwjhW8HRZXQ4fZHVjvszg" target="blank"><strong>Ingram</strong></a> <em>(direct from distributor)</em></li>
            <li><a href="https://www.amazon.com/dp/B0FZC6DSC4" target="blank"><strong>Amazon</strong></a></li>
            <li><a href="https://www.amazon.com/dp/B0GRCVCJ14" target="blank"><strong>Audible</strong></a></li>
          </ul>
          <div className="lp_announcements_content">
        <div class="lp_book-details_text"><strong>Or, become a newsletter subscriber to receive a promotional discount:</strong></div>

        <div className="newsletter-form">
          <form
            id="subscription-form"
            onSubmit={(e) => {
              e.preventDefault();
              const data = new FormData(e.target);
              console.log(data);
              subscribeUser(data);
            }}
            className="subscription-form"
          >
            <div className="newsletter-field">

              {/* <label htmlFor="email" className="subscription-form__label">
            Email
          </label> */}
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Enter your email"
                required
                className="subscription-form__input"
              />
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className={`subscription-form__button ${isLoading ? 'disabled' : ''}`}
            >
              {isLoading ? 'Signing up...' : 'Sign up'}
              <input type="hidden" name="status" value="unconfirmed" />
            </button>
          </form>
          {subscriptionStatus && (
            <p
              className={`subscription-form__status ${subscriptionStatus.includes('Error') ? 'error' : 'success'
                }`}
            >
              {subscriptionStatus}
            </p>
          )}
        </div>
      </div>
        </div>
        <div className="lp_book-details_image">
          <img width="250px" src="images/book-photo-for-web.png" alt="Children of Nemia" />
        </div>
      </div>



      
    </section>
  );
};

export default LandingPage;

